import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import Button from '../shared/Button/Button';

interface ViewAgentDashboardDialogProps {
  agentType: 'call' | 'chat';
  open: boolean;
  onClose: () => void;
}

const ViewAgentDashboardDialog: React.FC<ViewAgentDashboardDialogProps> = ({
  agentType,
  open,
  onClose,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [agentId, setAgentId] = useState('');

  const handleClose = () => {
    setAgentId('');
    onClose();
  };

  const handleSubmit = () => {
    if (!agentId.trim()) return;
    const path =
      agentType === 'call'
        ? `/agents/${agentId.trim()}`
        : `/agents/chat/${agentId.trim()}`;
    handleClose();
    navigate(path);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('View Agent Dashboard')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField
            label={t('Agent ID')}
            value={agentId}
            onChange={e => setAgentId(e.target.value)}
            fullWidth
            autoFocus
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="outlined"
          color="inherit"
          size="small"
          onClick={handleClose}
        >
          {t('Cancel')}
        </Button>
        <Button size="small" disabled={!agentId.trim()} onClick={handleSubmit}>
          {t('View Dashboard')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewAgentDashboardDialog;
